import React, { useContext, useEffect, useState } from 'react';
import { quoteContext } from '../../context/quotesContext';
import { CustonInput } from '../CustonInput';
import { states } from '../../constants/states';
import { getColCitiesData } from '../api';
import usaFlag from '../../../public/assets/usaFlag.png'
import colFlag from '../../../public/assets/colFlag.png'
import { useTranslation } from "react-i18next";

const StepFromAndTo = () => {
    const [ t ]= useTranslation();
    const {
        fromZipCode,
        setFromZipCode,
        toCity,
        setToCity,
        state,
        setState,
        setStateOption,
        stateOption,
        colCities,
        setColCities,
        loading, 
        setLoading,
        colCitiesOptions, 
        setColCitiesOptions,
        setCityOption,
        cityOptionSelected, 
        setCityOptionSelected,
        setFromAndToCompleted
    } = useContext(quoteContext);

    const statesOption =  states.length > 0 &&  states.map(state => ({
        ...state,
        label: state.state
    }));

    useEffect(() => {
        const fetchColCitiesData = async () => {
            try {
                setLoading(true);
                const result = await getColCitiesData();
                setColCities(result);

                if (result && result.cities) {
                    const coCitiesFiltered = result.cities.map(city => ({
                        ...city,
                        label: `${city.city}, ${city.state},  ${city.country}`,
                    }));
                
                    setColCitiesOptions(coCitiesFiltered);
                }
            } catch (error) {
                console.error('Error fetching data', error);
            } finally {
                setLoading(false);
            }
        };
        fetchColCitiesData();
    }, []);



    useEffect(()=> {
        if(cityOptionSelected && stateOption && fromZipCode!== '') {
            setFromAndToCompleted(true);
        }
    },[cityOptionSelected, stateOption, fromZipCode]);

    if(loading) {
        return (<></>)
    }
    return (
        <div className='from-and-to-container'>
            <div className="postcode">
                <CustonInput
                    name={'zip-code'}
                    label={t('postal_code')}
                    placeholder='0000'
                    imageSrc={usaFlag}
                    className='postCode'
                    value={fromZipCode}
                    onChange={(e)=>setFromZipCode(e)}
                    autoComplete="off"
                >
                </CustonInput>
                <CustonInput
                    label={t('From')}
                    name={'state'}
                    placeholder='New York'
                    className="large from"
                    onChange={(e)=>setState(e)}
                    value={state}
                    options={statesOption}
                    haslist={true}
                    onSelectOption={setStateOption}
                    autoComplete="off"
                    autoOpenOnFocus={true}
                >

                </CustonInput>
            </div>

            <CustonInput
                label={t('to')}
                name={'co-city'}
                placeholder='Neiva, Huila'
                className='xlarge'
                imageSrc={colFlag}
                onChange={(e)=>setToCity(e)}
                value={toCity}
                options={colCitiesOptions}
                haslist={true}
                onSelectOption={setCityOptionSelected}
                autoComplete="off"
                autoOpenOnFocus={true}
            >

            </CustonInput>
        </div>
    );
}

export { StepFromAndTo }